import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantesService {
  public ID_CATALOGO_LIMITE_SEMAFORO: number = 1;
  public ID_CATALOGO_FRECUENCIAS_CONTROL: number = 2;
  public ID_CATALOGO_TIPO_DATO: number = 4;
  public ID_CATALOGO_TIPO_DOCUMENTO: number = 5;
  public ID_CATALOGO_TIPO_INDICADOR: number = 7;
  public ID_CATALOGO_TIPO_PROCEDIMIENTO_ALMACENADO: number = 8;
  public ID_CATALOGO_NORMATIVA: number = 9;

  public TIPO_DATO_TEXTO: string = '1';
  public TIPO_DATO_NUMERO: string = '2';
  public TIPO_DATO_FECHA: string = '3';
  public TIPO_DATO_LISTA: string = '4';
  public TIPO_DATO_LISTA_MULTIPLE: string = '5';
  public TIPO_DATO_VERDADERO_FALSO: string = '6';

  public MULTIPLES_ARCHIVOS: string = 'Ver archivos';
  public SEPARADOR: string = ",";

  public DESCRIPCION_PRIMER_NIVEL_PLAN_SESION = "DESCRIPCION_PRIMER_NIVEL_PLAN_ACTUAL";
  public DESCRIPCION_ULTIMO_NIVEL_PLAN_SESION = "DESCRIPCION_ULTIMO_NIVEL_PLAN_ACTUAL";
  public OPCION_AGREGAR_REGISTRO = "AGREGAR_REGISTRO";

  public FORMA_MEDICION_CANTIDAD: number = 1;
  public FORMA_MEDICION_PORCENTAJE: number =2;

  public ESTADO_COMPLETADO: Boolean = true;
  public ID_PLAN_PNLOTI: number = 1;

  public GOBIERNO_REGIONAL: string = "Gobierno Regional de "

  public TIPO_USUARIO_ADMINISTRADOR_SISTEMA: string = "1"//"ADMINISTRADOR_SISTEMA";
  public TIPO_USUARIO_ADMINISTRADOR: string = "2"//"ADMINISTRADOR";
  public TIPO_USUARIO_OPERADOR: string = "3"//"OPERADOR";
  public TIPO_USUARIO_CONSULTA: string = "4"//"CONSULTA";

  public CODIGO_FRECUENCIA_ANUAL: string = "5"

  public CODIGO_ESTA_APROBADO: string = '1';

  public CODIGO_ESTA_DESAPROBADO: string = '2';

  public ID_PAIS_PERU: number = 177;

  public MAX_TAMANIO_ARCHIVO: number = 30*1024*1024;

  public ESTA_PUBLICADO: string = '1';
  public NO_ESTA_PUBLICADO: string = '0';

  constructor() { }
}

